// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-btn-toggle[data-v-b07c00fe] .v-btn{-webkit-filter:grayscale(1);filter:grayscale(1)}.v-btn-toggle[data-v-b07c00fe] .v-btn--active{-webkit-filter:none!important;filter:none!important}", ""]);
// Exports
module.exports = exports;
